import { updateSlide } from "store/common/common-slice";
import { useRootDispatch, useRootSelector } from "store/hooks";

import { useTranslation } from "react-i18next";
import classes from "./scheduledPayments.module.scss";
import {
  getAccountRestrictions,
  selectedAccountInfo,
} from "store/account/account-selector";
import { useMemo } from "react";

export const ScheduledPaymentsActions = () => {
  const { t } = useTranslation(["common"]);
  const dispatch = useRootDispatch();
  const accountInfo = useRootSelector(selectedAccountInfo);
  const { restrictions } = useRootSelector(getAccountRestrictions);

  const actionDisabled: boolean = useMemo(() => {
    return (
      accountInfo?.active !== true ||
      (restrictions.achRestricted && restrictions.cardRestricted)
    );
  }, [accountInfo, restrictions]);

  return (
    <>
      <ft-button
        class={classes.ScheduledButtons}
        aria-label={t("common:make_payment_label")}
        title={t("common:make_payment_label")}
        disabled={actionDisabled ? actionDisabled : null}
        outlined
        onClick={() => {
          dispatch(updateSlide({ id: "MakeAPayment" }));
        }}
      >
        <ft-icon>add</ft-icon>
      </ft-button>
      <ft-button
        class={[classes.ScheduledButtons, "outline-button"].join(" ")}
        aria-label={t("common:manage_autopay")}
        title={t("common:manage_autopay")}
        unelevated
        disabled={actionDisabled ? actionDisabled : null}
        onClick={() => {
          dispatch(updateSlide({ id: "ManageWallet", tab: 1 }));
        }}
      >
        <ft-icon>settings</ft-icon>
      </ft-button>
    </>
  );
};
